export const FETCH_PRICE_TRACKS = '/price-tracks/';
export const FETCH_PRICE_TRACK = (id: string) => `/price-tracks/${id}`;
export const ADD_PRICE_TRACK = '/price-tracks/add';
export const FETCH_FILTERED_MEMBERS_ANALYSIS_PRICE_TRACK = '/price-tracks/reports/members/filters';
export const FETCH_FILTERED_MEMBERS_ANALYSIS_PAST_PERFORMANCE_PRICE_TRACK = (id: string) =>
  `/price-tracks/reports/members/filters/past-performance/${id}`;
export const FETCH_CHARTDATA_PRICE_TRACK = (id: number) => `/price-tracks/reports/data/${id}`;
export const FETCH_MEMBERS_ANALYSIS_PRICE_TRACK = '/price-tracks/chart/members';
